<p-dialog
  [(visible)]="displayFailedDeleteList"
  [header]="'error.summary.restricted' | transloco"
  [modal]="true"
  [style]="{width: '50vw'}"
  [draggable]="false"
  [resizable]="true"
>
  <div class="flex align-items-center">
    <i class="pi pi-ban p-error text-4xl mr-3"></i>
    <span>{{'error.delete.restrictedList' | transloco}}</span>
  </div>
  <p-scrollPanel class="ml-2" [style]="{width: '100%', height: '100%'}">
    <div class="flex justify-content-center">
      <ul>
        <li *ngFor="let item of failedDeleteList">
          {{item.name}} ({{item.tenant.name}})
        </li>
      </ul>
    </div>
  </p-scrollPanel>
</p-dialog>
<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-cog title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.deviceCategories' | transloco}}</p>
        <p>{{'menu.descriptions.deviceCategories' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(selection)]="selected"
          [(first)]="first"
          [(rows)]="rows"
          [value]="categories"
          [totalRecords]="totalCategories"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width" *ngIf="'ROLE_ADMIN' | userHasRole"></th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
              <th pSortableColumn="description">
                {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
              <th pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}<p-sortIcon field="tenant.name"></p-sortIcon></th>
              <th *ngIf="'ROLE_ADMIN' | userHasRole" class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-category>
            <tr *ngIf="!loadingCategories" class="fadein">
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="category"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                {{category.name}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                {{category.description}}
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="category.tenant" [routerLink]="['/management/tenants', category.tenant.uuid, 'details']">
                  {{category.tenant.name}}
                </a>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    [routerLink]="[category.tenant.uuid, category.name, 'edit']"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    (click)="confirmAndDelete(category)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingCategories" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalCategories == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalCategories > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalCategories ? totalCategories : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalCategories}}
              {{(totalCategories > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="description">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.description"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="description"
          type="text"
        >
      </div>
    </div>
    <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
      <div class="col-12 form-field">
        <label for="tenant">{{'model.tenant' | transloco}}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.tenantUuids"
          [placeholder]="'select.generic' | transloco"
          [options]="tenants"
          [filter]="true"
          styleClass="w-full"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
          filterBy="name"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.description ||
          currentFilters.tenantUuids
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
